import React, { useState } from 'react';
import { Button } from './ui/button';
import ClientDetail from './ClientDetail';
import { Input } from './ui/input';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { 
  Users, 
  Search, 
  Plus, 
  Filter, 
  Download, 
  Star, 
  Crown, 
  Diamond, 
  Award,
  Eye,
  Mail,
  Phone,
  MapPin,
  Calendar,
  TrendingUp,
  DollarSign,
  UserCheck,
  X,
  Heart,
  Briefcase
} from 'lucide-react';

const ClientsBase = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [clientTypeFilter, setClientTypeFilter] = useState('all');
  const [locationFilter, setLocationFilter] = useState('all');
  const [vipLevelFilter, setVipLevelFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [selectedClient, setSelectedClient] = useState(null);
  const [showClientDetail, setShowClientDetail] = useState(false);

  // Base de données clients étendue
  const clientsData = [
    {
      id: 1,
      name: 'Nicolas Beaumont',
      email: 'nicolas.beaumont@email.com',
      phone: '+33 6 12 34 56 78',
      location: 'Paris, France',
      nationality: 'Française',
      vipLevel: 'Gold',
      clientType: 'Individual',
      status: 'Active',
      totalSpent: 458000,
      reservations: {
        completed: 8,
        upcoming: 2,
        cancelled: 1
      },
      lastStay: '2024-09-15',
      nextStay: '2025-01-20',
      joinDate: '2019-03-15',
      preferences: ['Suite Master', 'Yoga matinal', 'Cuisine végétarienne', 'Spa wellness'],
      notes: 'Client fidèle, préfère les destinations méditerranéennes',
      satisfaction: 4.9,
      avatar: 'NB'
    },
    {
      id: 2,
      name: 'James Davidson',
      email: 'james@davidson.com',
      phone: '+1 555 0123',
      location: 'New York, USA',
      nationality: 'Américaine',
      vipLevel: 'Black',
      clientType: 'Corporate',
      status: 'Active',
      totalSpent: 2400000,
      reservations: {
        completed: 18,
        upcoming: 3,
        cancelled: 0
      },
      lastStay: '2024-11-15',
      nextStay: '2025-02-10',
      joinDate: '2018-06-20',
      preferences: ['Villa privée', 'Chef personnel', 'Yacht charter', 'Héliport'],
      notes: 'CEO Fortune 500, réservations groupe, événements corporate',
      satisfaction: 4.8,
      avatar: 'JD'
    },
    {
      id: 3,
      name: 'Isabella Rodriguez',
      email: 'isabella@rodriguez-foundation.org',
      phone: '+34 91 234 5678',
      location: 'Madrid, Espagne',
      nationality: 'Espagnole',
      vipLevel: 'Diamond',
      clientType: 'Individual',
      status: 'Active',
      totalSpent: 850000,
      reservations: {
        completed: 12,
        upcoming: 1,
        cancelled: 2
      },
      lastStay: '2024-10-01',
      nextStay: '2025-03-15',
      joinDate: '2020-01-10',
      preferences: ['Spa premium', 'Équitation', 'Art contemporain', 'Cuisine végane'],
      notes: 'Philanthrope, préfère les propriétés éco-responsables',
      satisfaction: 4.9,
      avatar: 'IR'
    },
    {
      id: 4,
      name: 'Alexander Chen',
      email: 'alex@chen-tech.sg',
      phone: '+65 9876 5432',
      location: 'Singapour',
      nationality: 'Singapourienne',
      vipLevel: 'Platinum',
      clientType: 'Individual',
      status: 'Active',
      totalSpent: 620000,
      reservations: {
        completed: 9,
        upcoming: 2,
        cancelled: 0
      },
      lastStay: '2024-08-25',
      nextStay: '2025-01-08',
      joinDate: '2021-04-12',
      preferences: ['Tech smart home', 'Golf privé', 'Sushi chef', 'Fitness trainer'],
      notes: 'Tech entrepreneur, aime les innovations et gadgets',
      satisfaction: 4.7,
      avatar: 'AC'
    },
    {
      id: 5,
      name: 'Sophie Laurent',
      email: 'sophie@laurent-design.com',
      phone: '+33 1 45 67 89 12',
      location: 'Cannes, France',
      nationality: 'Française',
      vipLevel: 'Gold',
      clientType: 'Individual',
      status: 'Inactive',
      totalSpent: 180000,
      reservations: {
        completed: 6,
        upcoming: 0,
        cancelled: 1
      },
      lastStay: '2023-07-28',
      nextStay: null,
      joinDate: '2022-02-18',
      preferences: ['Design moderne', 'Boutiques privées', 'Photographie', 'Gastronomie'],
      notes: 'Designer de mode, client saisonnier',
      satisfaction: 4.6,
      avatar: 'SL'
    },
    {
      id: 6,
      name: 'Mohammed Al-Rashid',
      email: 'mohammed@alrashid-group.ae',
      phone: '+971 50 123 4567',
      location: 'Dubai, UAE',
      nationality: 'Émiratie',
      vipLevel: 'Black',
      clientType: 'Corporate',
      status: 'Active',
      totalSpent: 3200000,
      reservations: {
        completed: 25,
        upcoming: 4,
        cancelled: 1
      },
      lastStay: '2024-12-01',
      nextStay: '2025-01-15',
      joinDate: '2017-09-30',
      preferences: ['Famille étendue', 'Halal cuisine', 'Plage privée', 'Services enfants'],
      notes: 'Magnat immobilier, séjours famille nombreuse',
      satisfaction: 5.0,
      avatar: 'MA'
    },
    {
      id: 7,
      name: 'Emma Thompson',
      email: 'emma@thompson-law.uk',
      phone: '+44 20 7946 0958',
      location: 'London, UK',
      nationality: 'Britannique',
      vipLevel: 'Platinum',
      clientType: 'Individual',
      status: 'Active',
      totalSpent: 420000,
      reservations: {
        completed: 7,
        upcoming: 1,
        cancelled: 0
      },
      lastStay: '2024-09-12',
      nextStay: '2025-04-22',
      joinDate: '2020-11-08',
      preferences: ['Quiet luxury', 'Library/Reading', 'Afternoon tea', 'Countryside'],
      notes: 'Avocate prestigieuse, préfère la discrétion',
      satisfaction: 4.8,
      avatar: 'ET'
    },
    {
      id: 8,
      name: 'Hiroshi Tanaka',
      email: 'hiroshi@tanaka-corp.jp',
      phone: '+81 3 1234 5678',
      location: 'Tokyo, Japon',
      nationality: 'Japonaise',
      vipLevel: 'Diamond',
      clientType: 'Corporate',
      status: 'Active',
      totalSpent: 1100000,
      reservations: {
        completed: 14,
        upcoming: 2,
        cancelled: 0
      },
      lastStay: '2024-10-15',
      nextStay: '2025-02-28',
      joinDate: '2019-08-14',
      preferences: ['Onsen/Spa japonais', 'Kaiseki cuisine', 'Zen gardens', 'Golf traditionnel'],
      notes: 'PDG tech, respect protocole japonais',
      satisfaction: 4.9,
      avatar: 'HT'
    }
  ];

  // Statistiques globales
  const globalStats = {
    totalClients: clientsData.length,
    activeClients: clientsData.filter(c => c.status === 'Active').length,
    totalRevenue: clientsData.reduce((acc, client) => acc + client.totalSpent, 0),
    avgSatisfaction: (clientsData.reduce((acc, client) => acc + client.satisfaction, 0) / clientsData.length).toFixed(1),
    vipDistribution: {
      Black: clientsData.filter(c => c.vipLevel === 'Black').length,
      Diamond: clientsData.filter(c => c.vipLevel === 'Diamond').length,
      Platinum: clientsData.filter(c => c.vipLevel === 'Platinum').length,
      Gold: clientsData.filter(c => c.vipLevel === 'Gold').length
    }
  };

  // Fonctions de filtrage
  const getFilteredClients = () => {
    return clientsData.filter(client => {
      const matchesSearch = searchQuery === '' || 
        client.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        client.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        client.location.toLowerCase().includes(searchQuery.toLowerCase());

      const matchesType = clientTypeFilter === 'all' || client.clientType === clientTypeFilter;
      const matchesLocation = locationFilter === 'all' || client.nationality === locationFilter;
      const matchesVip = vipLevelFilter === 'all' || client.vipLevel === vipLevelFilter;
      const matchesStatus = statusFilter === 'all' || client.status === statusFilter;

      return matchesSearch && matchesType && matchesLocation && matchesVip && matchesStatus;
    });
  };

  const getVipIcon = (level) => {
    switch(level) {
      case 'Black': return <Crown className="w-4 h-4" />;
      case 'Diamond': return <Diamond className="w-4 h-4" />;
      case 'Platinum': return <Award className="w-4 h-4" />;
      case 'Gold': return <Star className="w-4 h-4" />;
      default: return <UserCheck className="w-4 h-4" />;
    }
  };

  const getVipColor = (level) => {
    switch(level) {
      case 'Black': return 'bg-black text-yellow-500';
      case 'Diamond': return 'bg-blue-500 text-white';
      case 'Platinum': return 'bg-gray-400 text-white';
      case 'Gold': return 'bg-yellow-500 text-white';
      default: return 'bg-gray-200 text-gray-800';
    }
  };

  const getStatusColor = (status) => {
    return status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800';
  };

  const resetFilters = () => {
    setSearchQuery('');
    setClientTypeFilter('all');
    setLocationFilter('all');
    setVipLevelFilter('all');
    setStatusFilter('all');
  };

  const viewClientDetail = (client) => {
    // Enrichir les données client pour la page de détail
    const enrichedClient = {
      ...client,
      personalInfo: {
        dateOfBirth: '1985-04-12',
        profession: 'Directeur Marketing',
        company: 'Beaumont & Associates',
        address: '75 Avenue des Champs-Élysées, 75008 Paris',
        emergencyContact: {
          name: 'Contact Urgence',
          relation: 'Famille',
          phone: '+33 6 98 76 54 32'
        }
      },
      preferences: {
        accommodation: client.preferences || ['Suite Master', 'Vue mer', 'Balcon privé'],
        dining: ['Cuisine végétarienne', 'Room service', 'Wine pairing'],
        activities: ['Yoga matinal', 'Spa wellness', 'Golf'],
        services: ['Concierge 24h', 'Transport privé', 'Housekeeping'],
        special: ['Silence après 22h', 'Allergique aux fruits de mer']
      },
      stats: {
        totalReservations: client.reservations?.completed || 9,
        totalNights: 56,
        averageStayDuration: 6.2,
        preferredDestinations: ['France', 'Italie', 'Grèce'],
        seasonalPattern: { spring: 3, summer: 4, autumn: 2, winter: 0 },
        guestPattern: { solo: 1, couple: 3, family: 4, group: 1 }
      },
      reservations: {
        completed: [
          {
            id: 'RES001',
            property: 'Villa Côte d\'Azur',
            location: 'Cannes, France',
            dates: '2024-07-15 - 2024-07-22',
            duration: 7,
            guests: 4,
            amount: 52500,
            status: 'Completed',
            rating: 5,
            notes: 'Séjour parfait, client très satisfait'
          }
        ],
        upcoming: client.reservations?.upcoming ? [
          {
            id: 'RES004',
            property: 'Villa Mykonos',
            location: 'Mykonos, Grèce',
            dates: '2025-06-15 - 2025-06-22',
            duration: 7,
            guests: 8,
            amount: 75000,
            status: 'Confirmed',
            specialRequests: ['Chef personnel', 'Yacht excursion']
          }
        ] : [],
        cancelled: []
      },
      communications: [
        {
          id: 1,
          date: '2024-12-10',
          type: 'Email',
          subject: 'Confirmation réservation',
          status: 'Sent',
          author: 'Sarah Martin'
        }
      ],
      notes: [
        {
          id: 1,
          date: '2024-12-10',
          author: 'Sarah Martin',
          type: 'Important',
          content: 'Client fidèle, préfère les destinations méditerranéennes.'
        }
      ]
    };
    
    setSelectedClient(enrichedClient);
    setShowClientDetail(true);
  };

  const filteredClients = getFilteredClients();

  // Si on affiche le détail client, on affiche le composant ClientDetail
  if (showClientDetail && selectedClient) {
    return (
      <ClientDetail 
        clientId={selectedClient.id}
        clientData={selectedClient}
        onBack={() => setShowClientDetail(false)}
      />
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 text-white p-8 relative overflow-hidden">
        <div className="absolute top-0 right-20 text-8xl opacity-10">
          <Users className="w-32 h-32" />
        </div>
        <h1 className="text-4xl font-light tracking-widest mb-2 relative z-10">BASE CLIENTS</h1>
        <p className="text-sm tracking-wider opacity-90 relative z-10">Gestion complète de votre portefeuille client luxury</p>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-yellow-600"></div>
      </div>

      {/* Statistiques globales */}
      <div className="bg-white p-6 shadow-sm">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
          <div className="text-center">
            <div className="text-2xl font-light text-blue-700">{globalStats.totalClients}</div>
            <div className="text-xs uppercase tracking-wide text-gray-500">Clients Totaux</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-light text-green-700">{globalStats.activeClients}</div>
            <div className="text-xs uppercase tracking-wide text-gray-500">Clients Actifs</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-light text-yellow-700">€{(globalStats.totalRevenue / 1000000).toFixed(1)}M</div>
            <div className="text-xs uppercase tracking-wide text-gray-500">Revenue Total</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-light text-purple-700">{globalStats.avgSatisfaction}/5</div>
            <div className="text-xs uppercase tracking-wide text-gray-500">Satisfaction Moy.</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-light text-black">{globalStats.vipDistribution.Black}</div>
            <div className="text-xs uppercase tracking-wide text-gray-500">Clients Black</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-light text-blue-700">{globalStats.vipDistribution.Diamond}</div>
            <div className="text-xs uppercase tracking-wide text-gray-500">Clients Diamond</div>
          </div>
        </div>
      </div>

      {/* Système de filtres */}
      <div className="bg-white p-6 border-t shadow-sm">
        <div className="flex flex-wrap gap-4 items-end">
          {/* Recherche principale */}
          <div className="flex-1 min-w-80">
            <label className="text-xs uppercase tracking-wide text-gray-500">Recherche client</label>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
              <Input 
                placeholder="Nom, email, localisation..." 
                className="pl-10"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          {/* Type de client */}
          <div className="flex flex-col gap-1">
            <label className="text-xs uppercase tracking-wide text-gray-500">Type Client</label>
            <Select value={clientTypeFilter} onValueChange={setClientTypeFilter}>
              <SelectTrigger className="w-40">
                <SelectValue placeholder="Tous types" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tous types</SelectItem>
                <SelectItem value="Individual">Individual</SelectItem>
                <SelectItem value="Corporate">Corporate</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Nationalité */}
          <div className="flex flex-col gap-1">
            <label className="text-xs uppercase tracking-wide text-gray-500">Nationalité</label>
            <Select value={locationFilter} onValueChange={setLocationFilter}>
              <SelectTrigger className="w-40">
                <SelectValue placeholder="Toutes" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Toutes</SelectItem>
                <SelectItem value="Française">France</SelectItem>
                <SelectItem value="Américaine">USA</SelectItem>
                <SelectItem value="Britannique">UK</SelectItem>
                <SelectItem value="Espagnole">Espagne</SelectItem>
                <SelectItem value="Émiratie">UAE</SelectItem>
                <SelectItem value="Japonaise">Japon</SelectItem>
                <SelectItem value="Singapourienne">Singapour</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Niveau VIP */}
          <div className="flex flex-col gap-1">
            <label className="text-xs uppercase tracking-wide text-gray-500">Niveau VIP</label>
            <Select value={vipLevelFilter} onValueChange={setVipLevelFilter}>
              <SelectTrigger className="w-32">
                <SelectValue placeholder="Tous" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tous</SelectItem>
                <SelectItem value="Black">Black</SelectItem>
                <SelectItem value="Diamond">Diamond</SelectItem>
                <SelectItem value="Platinum">Platinum</SelectItem>
                <SelectItem value="Gold">Gold</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Statut */}
          <div className="flex flex-col gap-1">
            <label className="text-xs uppercase tracking-wide text-gray-500">Statut</label>
            <Select value={statusFilter} onValueChange={setStatusFilter}>
              <SelectTrigger className="w-32">
                <SelectValue placeholder="Tous" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tous</SelectItem>
                <SelectItem value="Active">Actif</SelectItem>
                <SelectItem value="Inactive">Inactif</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Actions */}
          <div className="flex gap-2">
            <Button variant="outline" onClick={resetFilters}>
              <X className="w-4 h-4 mr-2" />
              Reset
            </Button>
            <Button className="bg-yellow-600 hover:bg-yellow-700 text-black">
              <Plus className="w-4 h-4 mr-2" />
              Nouveau Client
            </Button>
            <Button variant="outline">
              <Download className="w-4 h-4 mr-2" />
              Export
            </Button>
          </div>
        </div>

        {/* Résultats de filtrage */}
        <div className="mt-4 flex items-center justify-between">
          <p className="text-sm text-gray-600">
            {filteredClients.length} client(s) trouvé(s) sur {clientsData.length} total
          </p>
        </div>
      </div>

      {/* Liste des clients */}
      <div className="p-6">
        <div className="grid gap-4">
          {filteredClients.map((client) => (
            <Card key={client.id} className="hover:shadow-lg transition-all">
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-semibold">
                      {client.avatar}
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-1">
                        <h3 className="text-lg font-semibold">{client.name}</h3>
                        <div className={`w-8 h-8 rounded-full ${getVipColor(client.vipLevel)} flex items-center justify-center`}>
                          {getVipIcon(client.vipLevel)}
                        </div>
                        <Badge className={getStatusColor(client.status)}>
                          {client.status === 'Active' ? 'Actif' : 'Inactif'}
                        </Badge>
                        <Badge variant="outline">
                          {client.clientType}
                        </Badge>
                      </div>
                      <div className="flex items-center gap-4 text-sm text-gray-600">
                        <div className="flex items-center gap-1">
                          <Mail className="w-3 h-3" />
                          {client.email}
                        </div>
                        <div className="flex items-center gap-1">
                          <Phone className="w-3 h-3" />
                          {client.phone}
                        </div>
                        <div className="flex items-center gap-1">
                          <MapPin className="w-3 h-3" />
                          {client.location}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-8">
                    <div className="text-center">
                      <div className="text-lg font-semibold text-green-600">€{(client.totalSpent / 1000).toLocaleString()}K</div>
                      <div className="text-xs text-gray-500">Total dépensé</div>
                    </div>
                    <div className="text-center">
                      <div className="text-lg font-semibold text-blue-600">{client.reservations.completed}</div>
                      <div className="text-xs text-gray-500">Séjours</div>
                    </div>
                    <div className="text-center">
                      <div className="text-lg font-semibold text-yellow-600">{client.satisfaction}/5</div>
                      <div className="text-xs text-gray-500">Satisfaction</div>
                    </div>
                    <div className="text-center">
                      <div className="text-lg font-semibold text-purple-600">{client.reservations.upcoming}</div>
                      <div className="text-xs text-gray-500">À venir</div>
                    </div>
                    <Button 
                      onClick={() => viewClientDetail(client)}
                      className="bg-blue-700 hover:bg-blue-800 text-white"
                    >
                      <Eye className="w-4 h-4 mr-2" />
                      Voir détail
                    </Button>
                  </div>
                </div>

                {/* Informations complémentaires */}
                <div className="mt-4 pt-4 border-t">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <h4 className="text-sm font-medium text-gray-700 mb-2">Préférences principales</h4>
                      <div className="flex flex-wrap gap-1">
                        {client.preferences.slice(0, 3).map((pref, index) => (
                          <Badge key={index} variant="secondary" className="text-xs">
                            {pref}
                          </Badge>
                        ))}
                        {client.preferences.length > 3 && (
                          <Badge variant="outline" className="text-xs">
                            +{client.preferences.length - 3}
                          </Badge>
                        )}
                      </div>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-gray-700 mb-2">Activité récente</h4>
                      <div className="flex items-center gap-4 text-sm text-gray-600">
                        <div className="flex items-center gap-1">
                          <Calendar className="w-3 h-3" />
                          Dernier séjour: {new Date(client.lastStay).toLocaleDateString('fr-FR')}
                        </div>
                        {client.nextStay && (
                          <div className="flex items-center gap-1">
                            <Calendar className="w-3 h-3" />
                            Prochain: {new Date(client.nextStay).toLocaleDateString('fr-FR')}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientsBase;